import PropTypes from 'prop-types';

export const Props = {
  /**
   * Optional id to assign to the element
   */
  id: PropTypes.string,
  /**
   * If true, the row will never have horizontal spacing
   */
  noGutter: PropTypes.bool,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
